import type { PublicationCode } from '@/scopes/common/domain/models'

interface BreadcrumbConfig {
  catalogTextId?: string
  catalogUrl?: string
  homeUrl: string
}

const BREADCRUMBS_CONFIG: Partial<Record<PublicationCode, BreadcrumbConfig>> = {
  BW: {
    catalogTextId: 'breadcrumb_winter',
    catalogUrl: '/nl/skivakantie',
    homeUrl: '/nl',
  },
  BZ: {
    catalogTextId: 'breadcrumb_summer',
    catalogUrl: '/nl/vakantie',
    homeUrl: '/nl',
  },
  SZ: {
    catalogTextId: 'breadcrumb_summer',
    catalogUrl: '/vakantie',
    homeUrl: '/',
  },
  WG: {
    catalogTextId: 'breadcrumb_winter',
    catalogUrl: '/wintersport',
    homeUrl: '/',
  },
  UW: {
    homeUrl: '/',
  },
  FS: {
    catalogTextId: 'breadcrumb_summer',
    catalogUrl: '/fr/vacances',
    homeUrl: '/fr',
  },
  FH: {
    catalogTextId: 'breadcrumb_winter',
    catalogUrl: '/fr/ski',
    homeUrl: '/fr',
  },
  QZ: {
    catalogTextId: 'breadcrumb_summer',
    catalogUrl: '/solresor',
    homeUrl: '/',
  },
  QW: {
    catalogTextId: 'breadcrumb_winter',
    catalogUrl: '/skidresor',
    homeUrl: '/',
  },
  KZ: {
    catalogTextId: 'breadcrumb_summer',
    catalogUrl: '/rejser',
    homeUrl: '/',
  },
  KW: {
    catalogTextId: 'breadcrumb_winter',
    catalogUrl: '/skiferie',
    homeUrl: '/',
  },
  FZ: {
    catalogTextId: 'breadcrumb_summer',
    catalogUrl: '/vacances',
    homeUrl: '/',
  },
  FW: {
    catalogTextId: 'breadcrumb_winter',
    catalogUrl: '/ski',
    homeUrl: '/',
  },
  DW: {
    catalogTextId: 'breadcrumb_winter',
    catalogUrl: '/skiurlaub',
    homeUrl: '/',
  },
  EZ: {
    homeUrl: '/',
  },
  BE: {
    homeUrl: '/',
  },
}

export function getBreadcrumbsConfig(publicationCode: PublicationCode): BreadcrumbConfig | null {
  return BREADCRUMBS_CONFIG[publicationCode] ?? null
}
